<script>
export default {
  props: {
    ident: String,
    state: String
  },
  mounted() {
    window.localStorage.setItem('oauthState', JSON.stringify({
      ident: this.ident,
      state: this.state,
    }))

    setTimeout(() => {
        window.close()
    }, 3000)
  }
}
</script>